/**
 * How many leading tags fit on one line, leaving room for the "+N" chip that
 * stands in for the rest whenever at least one tag has to be hidden.
 *
 * `widths` are the chips' natural pixel widths in display order, `gap` the
 * flex gap between neighbours, `available` the width the chips may use.
 */
export const countFittingTags = ({ widths, overflowWidth, available, gap }) => {
  const rowWidth =
    widths.reduce((sum, width) => sum + width, 0) +
    Math.max(widths.length - 1, 0) * gap;

  if (rowWidth <= available) {
    return widths.length;
  }

  let used = overflowWidth;
  let count = 0;

  for (const width of widths) {
    if (used + gap + width > available) {
      break;
    }
    used += gap + width;
    count += 1;
  }

  return count;
};
